import { render, staticRenderFns } from "./integralItem.vue?vue&type=template&id=5c2371e0&scoped=true&"
import script from "./integralItem.vue?vue&type=script&lang=js&"
export * from "./integralItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2371e0",
  null
  
)

export default component.exports